import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { useLocalStorage } from '@fourthwall/utils/dist/LocalStorage'
import { routing } from '@utils/routing'

import { SamplesView } from './SamplesView'
import { useSamplesBudgetBalance } from './hooks/useSamplesBudgetBalance'
import { useSamplesOffers } from './hooks/useSamplesOffers'

export const SamplesContainer = () => {
  const { samplesBudgetBalanceWithIncentive } = useSamplesBudgetBalance()
  const { samplesOffers } = useSamplesOffers()
  const { hasPermission } = useDashboardPermissions()
  const { localStorage } = useLocalStorage()
  const navigate = useNavigate()

  const getProductStatus = () => {
    if (!hasPermission('settings.samples.create')) return 'HIDDEN'

    if (samplesOffers.isLoading) return 'LOADING'

    if (!samplesOffers.enabled) return 'NO_PRODUCTS'

    return 'AVAILABLE'
  }

  const handleProductsManage = () => {
    navigate(routing.products.all.self)
  }

  const handleOrderCreate = () => {
    localStorage.set('samples.items', undefined)
    localStorage.set('samples.id', undefined)

    navigate(routing.settings.samples.order, { state: { showModal: true } })
  }

  return (
    <SamplesView
      credit={samplesBudgetBalanceWithIncentive}
      products={{ status: getProductStatus(), onManage: handleProductsManage }}
      onOrderCreate={handleOrderCreate}
    />
  )
}
